import { useContext, useEffect } from 'react'

import { fetchFlightCampaigns } from 'actions/FlightActions'
import { useAppSelector, useAppDispatch } from 'hooks/reduxHooks'
import GeoContext from 'contexts/geoContext'

const emptyList: App.ApiCallState<{ data: Array<App.FlightCampaign>, isEnabled: boolean }> = {
  fetching: true,
  data: [],
  error: undefined,
  isEnabled: false,
}

type Result = [
  campaigns: Array<App.FlightCampaign>,
  loading: boolean,
  isEnabled: boolean,
]

export function useFlightCampaigns(): Result {
  const dispatch = useAppDispatch()
  const { currentRegionCode } = useContext(GeoContext)

  useEffect(() => {
    dispatch(fetchFlightCampaigns(currentRegionCode))
  }, [currentRegionCode, dispatch])

  const campaigns = useAppSelector(state => state.flights.campaigns[currentRegionCode] ?? emptyList)

  return [campaigns.data, !!campaigns.fetching, campaigns.isEnabled]
}
